import UniversalHeader from "./UniversalHeader";

const TeacherHeader = () => {
  return (
    <>
     <UniversalHeader />
    </>
  );
};

export default TeacherHeader;
